import { string as yupString, object as yupObject } from 'yup';

export type FormValues = {
  firstName: string;
  lastName: string;
  email: string;
  company: string;
}

export const defaults = {
  title: 'Download success story',
  className: '',
  buttonLabel: 'Download'
};

export const config = {
  initialValues: {
    firstName: '',
    lastName: '',
    email: '',
    company: '',
  },
  validationSchema: yupObject({
    firstName: yupString().default('').required('Please enter your first name'),
    lastName: yupString().default('').required('Please enter your last name'),
    email: yupString().default('').required("Please enter your email address").email('Please enter a valid email address'),
    company: yupString().default(''),
  }),
  isInitialValid: false,
  validateOnBlur: false,
}

